import { LocalSandbox } from '@nirvana/shared/dtos/types/policies/common';
import { SelectOption } from '../../../../../../../../ui/gzDropdown/types';

export function getTitleForLocalSandbox(name: string | null, ip: string | null): string {
  if (name && ip) {
    return `${name} (${ip})`;
  }

  if (name) {
    return name;
  }

  if (ip) {
    return ip;
  }

  return '';
}

export function getDropdownSelectionFromLocalSandboxes(localSandboxes: LocalSandbox[]): SelectOption[] {
  return localSandboxes.map(sandbox => {
    return {
      title: getTitleForLocalSandbox(sandbox.name, sandbox.ip),
      value: sandbox.endpointId,
    };
  });
}
